import { useEffect, useState } from "react";
import { useReducedMotion } from "framer-motion";
import "./FadeInPanel.css";

const DEFAULT_FADE_DURATION = 0.35;
const FADE_IN_FALLBACK_MS = 500;

export default function FadeInPanel({
    children,
    className,
    style,
    onClick,
    fadeDuration = DEFAULT_FADE_DURATION,
    animationKey,
    active = true,
}) {
    const prefersReducedMotion = useReducedMotion();
    const [fadeInActive, setFadeInActive] = useState(() => prefersReducedMotion && active);
    const [fadeInForced, setFadeInForced] = useState(false);

    useEffect(() => {
        if (!active) {
            setFadeInActive(false);
            setFadeInForced(false);
            return undefined;
        }
        if (prefersReducedMotion) {
            setFadeInActive(true);
            setFadeInForced(false);
            return undefined;
        }
        setFadeInActive(false);
        setFadeInForced(false);
        let cancelled = false;
        const frame = requestAnimationFrame(() => {
            if (!cancelled) {
                setFadeInActive(true);
            }
        });
        const fallbackId = window.setTimeout(() => {
            if (!cancelled) {
                setFadeInActive(true);
                setFadeInForced(true);
            }
        }, FADE_IN_FALLBACK_MS);
        return () => {
            cancelled = true;
            cancelAnimationFrame(frame);
            window.clearTimeout(fallbackId);
        };
    }, [animationKey, prefersReducedMotion, active]);

    const panelClassName = [
        "fade-in-panel",
        fadeInActive ? "fade-in-panel--active" : "",
        fadeInForced ? "fade-in-panel--fallback" : "",
        className,
    ].filter(Boolean).join(" ");

    return (
        <div
            className={panelClassName}
            style={{
                ...style,
                "--fade-in-panel-duration": `${fadeDuration}s`,
            }}
            onClick={onClick}
        >
            {children}
        </div>
    );
}
